<script>
import appConfig from '@src/app.config';
import Layout from '@layouts/child';
import PageHeader from '@components/page-header';

import WebsitesForm from './WebsitesForm';
import { PageViewsTable } from 'coryallen-page-views';
import { CommunicationsTable } from 'coryallen-communications';
import iframePagePreview from '@views/global/iframe-page-preview';

export default {
  page: {
    title: 'Websites',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, WebsitesForm, PageViewsTable, CommunicationsTable, iframePagePreview },
  data() {
    return {
      title: 'Websites',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Websites', to: '/websites', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

      loading_roles: true,
      roles: [],

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Websites\\Models\\Website',
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
    this.fetch_roles();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/websites/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          if(!res.data.data[0].mail_recipients) { res.data.data[0].mail_recipients = []; }
          if(!res.data.data[0].site_navbar) {
            res.data.data[0].site_navbar = {type: 'site-navbar', init: 'Yes', left_nav: [], account_menu: []};
          }
          if(!res.data.data[0].site_footer) {
            res.data.data[0].site_footer = {type: 'site-footer', init: 'Yes', menu_1: [], menu_2: [], menu_3: [], menu_base: []};
          }
          if(!res.data.data[0].store_categories) {
            res.data.data[0].store_categories = [];
          }

          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.title;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/websites');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    fetch_roles() {
      this.loading_roles = true;
      this.$http.get('/api/roles/fetch').then(res => {
        // console.log(res);
        this.roles = res.data.data;
        this.loading_roles = false;
      }).catch(res => { this.loading_roles = false; this.popupErrors(res); });
    },
    update_website() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/websites/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_website() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }

      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this website?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> DELETE', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/websites/delete/'+this.item.id).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
              this.$router.push('/websites');
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Preview</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>
    <div v-if="item.id">

      <div v-show="tabIndex == 0">
        <div class="row mt-4">
          <div class="col-sm-3">
            <div class="card-box">
              <h5 class="mb-3 text-uppercase bg-gray-200 p-3"><Icon icon="ri:book-2-line"></Icon> About :</h5>
              <div class="table-responsive">
                <table class="table table-sm table-px-0">
                  <tbody>
                    <tr><th class="border-0">Website ID :</th><td class="border-0 small">{{item.website_id}}</td></tr>
                    <tr><th>Updated on :</th><td class="small" v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                    <tr><th>Created on :</th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="card-box p-0">
              <div class="card-header bg-primary text-white">Map preview</div>
              <div class="p-1">
                <img class="rounded w-100" :src="'https://maps.googleapis.com/maps/api/staticmap?center='+encodeURIComponent(item.site_latitude+','+item.site_longitude)+'&zoom=10&size=640x315&maptype=roadmap&markers='+encodeURIComponent(item.site_latitude+','+item.site_longitude)+'&key='+google_key+'&style=feature%3Aadministrative%7Celement%3Alabels.text.fill%7Ccolor%3A0x6195a0%7C&style=feature%3Aadministrative.province%7Celement%3Ageometry.stroke%7Cvisibility%3Aoff%7C&style=feature%3Alandscape%7Celement%3Ageometry%7Clightness%3A0%7Csaturation%3A0%7Ccolor%3A0xf5f5f2%7Cgamma%3A1%7C&style=feature%3Alandscape.man_made%7Celement%3Aall%7Clightness%3A-3%7Cgamma%3A1.00%7C&style=feature%3Alandscape.natural.terrain%7Celement%3Aall%7Cvisibility%3Aoff%7C&style=feature%3Apoi%7Celement%3Aall%7Cvisibility%3Aoff%7C&style=feature%3Apoi.park%7Celement%3Ageometry.fill%7Ccolor%3A0xbae5ce%7Cvisibility%3Aon%7C&style=feature%3Aroad%7Celement%3Aall%7Csaturation%3A-100%7Clightness%3A45%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Aall%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Ageometry.fill%7Ccolor%3A0xfac9a9%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Alabels.text%7Ccolor%3A0x4e4e4e%7C&style=feature%3Aroad.arterial%7Celement%3Alabels.text.fill%7Ccolor%3A0x787878%7C&style=feature%3Aroad.arterial%7Celement%3Alabels.icon%7Cvisibility%3Aoff%7C&style=feature%3Atransit%7Celement%3Aall%7Cvisibility%3Asimplified%7C&style=feature%3Atransit.station.airport%7Celement%3Alabels.icon%7Chue%3A0x0a00ff%7Csaturation%3A-77%7Cgamma%3A0.57%7Clightness%3A0%7C&style=feature%3Atransit.station.rail%7Celement%3Alabels.text.fill%7Ccolor%3A0x43321e%7C&style=feature%3Atransit.station.rail%7Celement%3Alabels.icon%7Chue%3A0xff6c00%7Clightness%3A4%7Cgamma%3A0.75%7Csaturation%3A-68%7C&style=feature%3Awater%7Celement%3Aall%7Ccolor%3A0xeaf6f8%7Cvisibility%3Aon%7C&style=feature%3Awater%7Celement%3Ageometry.fill%7Ccolor%3A0xc7eced%7C&style=feature%3Awater%7Celement%3Alabels.text.fill%7Clightness%3A-49%7Csaturation%3A-53%7Cgamma%3A0.79%7C'">
              </div>
            </div>

            <button v-if="hasRole(['Dev','Admin'])" type="button" class="btn btn-block btn-outline-danger" @click="delete_website" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:delete-bin-7-line" /> Delete Website</button>

          </div>

          <div class="col-sm-9">
            <div class="card-box">
              <b-form @submit.prevent="update_website">
                <WebsitesForm :item="item" :roles="roles"></WebsitesForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>

      <div v-show="tabIndex == 1">
        <div class="mt-4">

          <iframePagePreview v-if="tabIndex == 1 && item && item.id && item.website_domain" :item="{navbar: 1, footer: 1, slug: '/'}" :website="item"></iframePagePreview>
          <div v-else class="alert alert-warning">Error loading website preview. Be sure the website domain is set.</div>
        </div>
      </div>

      <div v-show="tabIndex == 2">
        <div class="mt-4">
          <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
        </div>
      </div>

    </div>
  </Layout>
</template>
